/* eslint-disable */
import { call, put, takeLatest } from "redux-saga/effects";
import { selectors as sessionSelectors } from "reducers/session";
import { store } from "store";
import { actions as notificationActions } from "reducers/notification";
import { actions as afipActions } from "reducers/afipPayments";
import { types } from "reducers/afipPayments";
import { transactionStatus } from "pages/transactions/constants";
import { INSUFFICIENT_SIGNATURES } from "util/responses";
import * as i18n from "util/i18n";
import { routerActions } from "connected-react-router";
import {
    afipFormsList,
    afipFormFields,
    afipFormFieldCode,
    afipTaxForms,
    afipPreparePayment,
    afipConfirmPayment,
    afipBarCodeGenerator,
} from "middleware/afipPayments";

const sagas = [
    takeLatest(types.AFIP_FORM_LIST_REQUEST, afipForm),
    takeLatest(types.AFIP_FORM_FIELDS_REQUEST, afipFields),
    takeLatest(types.AFIP_FORM_FIELDS_CODES_REQUEST, afipFieldsCodes),
    takeLatest(types.AFIP_TAX_FORMS_REQUEST, afipFormsTax),
    takeLatest(types.AFIP_BAR_CODE_REQUEST, afipGeneratorBarCode),
    takeLatest(types.AFIP_PAYMENT_PREPARE_REQUEST, afipPaymentPrepare),
    takeLatest(types.AFIP_PAYMENT_CONFIRM_REQUEST, afipPaymentConfirm),
];

export default sagas;

const ticketStates = {
    COR020W: "ERROR",
    COR023I: transactionStatus.PENDING,
    COR000I: transactionStatus.FINISHED,
    COR013I: transactionStatus.SCHEDULED,
    COR060I: transactionStatus.PROCESSING,
};

function* afipForm() {
    const response = yield call(afipFormsList);
    if (response.type === "W") {
        yield put({ type: types.AFIP_FORM_LIST_FAILURE });
        yield put(routerActions.push("/servicePayments"));
        yield put(notificationActions.showNotification(response.data.message, "error", ["servicePaymentsPage"]));
    } else {
        yield put({
            type: types.AFIP_FORM_LIST_SUCCESS,
            afipForms: response.data.data.AfipForms,
        });
    }
}

function* afipFields({ code }) {
    const response = yield call(afipFormFields, code);
    if (response.type === "W") {
        yield put({ type: types.AFIP_FORM_FIELDS_FAILURE });
        yield put(routerActions.push("/afip/newPayment"));
        yield put(notificationActions.showNotification(response.data.message, "error", ["newAfip"]));
    } else {
        yield put({
            type: types.AFIP_FORM_FIELDS_SUCCESS,
            afipFields: response.data.data.AfipFormFields,
        });
    }
}

function* afipFieldsCodes({ codForm, dynamicComboxValues, value }) {
    const response = yield call(afipFormFieldCode, { codForm, dynamicComboxValues, value });
    if (response.type === "W") {
        yield put({ type: types.AFIP_FORM_FIELDS_CODES_FAILURE });
        yield put(routerActions.push("/afip/newPayment"));
        yield put(notificationActions.showNotification(response.data.message, "error", ["newAfip"]));
    } else {
        yield put({
            type: types.AFIP_FORM_FIELDS_CODES_SUCCESS,
            afipByCodes: response.data.data.additionalProp,
        });
    }
}

function* afipFormsTax({ codForm, fieldForm }) {
    const response = yield call(afipTaxForms, { codForm, fieldForm });
    if (response.type === "W") {
        yield put({ type: types.AFIP_TAX_FORMS_FAILURE });
        yield put(routerActions.push("/afip/newPayment"));
        yield put(notificationActions.showNotification(response.data.data.message, "error", ["newAfip"]));
    } else {
        yield put({
            type: types.AFIP_TAX_FORMS_SUCCESS,
            afipTaxForm: response.data.data,
        });
    }
}

function* afipGeneratorBarCode({ codForm, fieldForm, taxForms, hash }) {
    const response = yield call(afipBarCodeGenerator, { codForm, fieldForm, taxForms, hash });
    if (response.type === "W") {
        yield put({ type: types.AFIP_BAR_CODE_FAILURE });
        yield put(afipActions.afipTaxFormsReducer(codForm, fieldForm));
        yield put(routerActions.push("/afip/newPayment/account"));
        yield put(notificationActions.showNotification(response.data.data.message, "error", ["newAfip.account"]));
    } else {
        yield put({
            type: types.AFIP_BAR_CODE_SUCCESS,
            afipBarCode: response.data.data,
        });
        yield put(routerActions.push("/afip/newPayment/sumary"));
    }
}

function* afipPaymentPrepare({
    paymentMethod,
    codForm,
    companyCode,
    companyName,
    barcode,
    amount,
    fieldForm,
    taxForms,
    hash,
}) {
    const response = yield call(afipPreparePayment, {
        paymentMethod,
        codForm,
        companyCode,
        companyName,
        barcode,
        amount,
        fieldForm,
        taxForms,
        hash,
    });
    if (response.type === "W") {
        yield put({ type: types.AFIP_PAYMENT_PREPARE_FAILURE });
        yield put(routerActions.push("/afip/newPayment/account"));
        yield put(notificationActions.showNotification(response.data.message, "error", ["newAfip.account"]));
    } else {
        yield put({
            type: types.AFIP_PAYMENT_PREPARE_SUCCESS,
            afipPaymentPrepare: response.data.data,
        });
    }
}

function* afipPaymentConfirm({ afipPaymentConfirm, formikBag, credentialType }) {
    const { setSubmitting, setErrors } = formikBag;
    const { userId } = sessionSelectors.getUser(store.getState());
    const params = { ...afipPaymentConfirm, userId, routeParam: "afip" };
    try {
        const response = yield call(afipConfirmPayment, params);
        if (response.type === "W" && response.data.code !== "API516W") {
            if (response.data.code === "COR020W") {
                if (response.data?.data?.password) {
                    const msj =
                        credentialType === "password"
                            ? "preferences.password.password.incorrect"
                            : "login.step1.secondFactor.invalid";
                    setErrors({
                        credential: i18n.get(msj),
                    });
                }
                if (response.data.data.otp) {
                    yield put(
                        notificationActions.showNotification(i18n.get("global.token.error"), "error", [
                            "afip.newPayment.sumary",
                        ]),
                    );
                } else {
                    yield put(
                        notificationActions.showNotification(response.data.data.message, "error", [
                            "afip.newPayment.sumary",
                        ]),
                    );
                }
            } else {
                const errorMessage =
                    response.data?.data?.NO_FIELD || response.data?.message || i18n.get("global.unexpectedError");
                setErrors(response.data.data);
                yield put(notificationActions.showNotification(errorMessage, "error", ["afip.newPayment.sumary"]));
            }
            yield put({ type: types.AFIP_PAYMENT_CONFIRM_FAILURE });
        } else {
            yield put({
                type: types.AFIP_PAYMENT_CONFIRM_SUCCESS,
            });
            if (response.data.code !== "API516W") {
                if (response.data.code === INSUFFICIENT_SIGNATURES) {
                    yield put(
                        notificationActions.showNotification(i18n.get("afip.pending.request"), "success", [
                            "afipTrasaction",
                        ]),
                    );
                } else {
                    yield put(
                        notificationActions.showNotification(i18n.get("afip.success.request"), "success", [
                            "afipTrasaction",
                        ]),
                    );
                }
            }
            yield put({
                type: types.AFIP_TICKET_SUCCESS,
                afipTicket: {
                    status: ticketStates[response.data.code],
                    ...response.data,
                },
            });
        }
    } finally {
        setSubmitting(false);
    }
}
